"use client";
import { motion } from "framer-motion";
import React from "react";

/* ─── Figma Corners ─── */
const CornerTL = ({ color }: { color: string }) => (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
    <path d="M0 0H8.32V1.5H1.51V6.2H0V0Z" fill={color} />
  </svg>
);
const CornerBL = ({ color }: { color: string }) => (
  <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
    <path d="M0 6.2H8.32V4.7H1.51V0H0V6.2Z" fill={color} />
  </svg>
);
const CornerTR = ({ color }: { color: string }) => (
  <svg width="8" height="7" viewBox="0 0 8 7" fill="none">
    <path d="M8.32 0H0V1.5H6.81V6.2H8.32V0Z" fill={color} />
  </svg>
);
const CornerBR = ({ color }: { color: string }) => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none">
    <path d="M8.32 6.2H0V4.7H6.81V0H8.32V6.2Z" fill={color} />
  </svg>
);

interface CyberButtonProps {
  children: React.ReactNode;
  icon?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
  active?: boolean;
  variant?: "filled" | "outline";
  borderColor?: string;
  cornerColor?: string;
  textColor?: string;
  background?: string;
  className?: string;
}

export default function CyberButton({
  children,
  icon,
  onClick,
  fullWidth,
  disabled,
  active,
  variant = "filled",
  borderColor = "rgba(255, 255, 255, 1)",
  cornerColor = "#FFFFFF",
  textColor = "#FFFFFF",
  background,
  className,
}: CyberButtonProps) {
  const filled = variant === "filled";
  const border = active ? "#00DAFF" : borderColor;
  //   const corner = disabled ? "rgba(255,255,255,0.4)" : border;
  const text = disabled ? "rgba(255,255,255,0.4)" : textColor;
  const bg =
    filled && !disabled
      ? background ??
        "linear-gradient(93.17deg, rgba(255, 0, 128, 0.3) 0%, rgba(0, 212, 255, 0.3) 100%)"
      : "transparent";

  return (
    <motion.button
      whileTap={!disabled ? { scale: 0.97 } : {}}
      whileHover={!disabled ? { scale: 1.02 } : {}}
      whileFocus={!disabled ? { borderColor: border } : {}}
      disabled={disabled}
      onClick={onClick}
      className={`cyber-border-cut overflow-hidden flex items-center justify-center gap-2 px-6 py-2 md:px-8 md:py-3 font-bold uppercase tracking-wide transition-all duration-300 ${
        fullWidth ? "w-full" : ""
      } ${disabled ? "opacity-60 cursor-not-allowed" : ""} ${className ?? ""}`}
      style={
        {
          background: bg,
          color: text,
          borderColor: border,
          borderRadius: 0,
          "--border-color": border,
        } as React.CSSProperties
      }
    >
      {/* ─── Corners ─── */}
      <div className="absolute top-0 left-0 z-10 corner">
        <CornerTL color={cornerColor} />
      </div>

      <div className="absolute bottom-0 left-0 z-10 corner">
        <CornerBL color={cornerColor} />
      </div>
      <div className="absolute top-0 right-0 z-10 corner">
        <CornerTR color={cornerColor} />
      </div>
      <div className="absolute bottom-0 right-0 z-10 corner">
        <CornerBR color={cornerColor} />
      </div>

      {/* ─── Content ─── */}
      <span className="z-10 flex items-center gap-2 text-sm md:text-base">
        {children}
        {icon && (
          <img
            src={icon}
            alt=""
            className="w-5 h-5 object-contain filter drop-shadow-[0_0_6px_rgba(0,218,255,0.7)]"
          />
        )}
      </span>
    </motion.button>
  );
}
